import { createSlice } from '@reduxjs/toolkit'
import {getWorkshopTypes} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';
const initialState= {
    workshopTypes: { },
  loading: "idle",
  error: null }

const workshopTypesSlice = createSlice({
  name: 'workshopTypes',
  initialState,
  reducers: {
    clearWorkshopTypesError: (state)=>{
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getWorkshopTypes.pending]: (state) => {
        state.loading = "loading";
        state.error = null
      },
    [getWorkshopTypes.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.workshopTypes = action.payload
    },
    [getWorkshopTypes.rejected]: (state, action) => {
        state.loading = "failed";
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {clearWorkshopTypesError} = workshopTypesSlice.actions;
export default workshopTypesSlice.reducer